// /src/utils/dateUtils.js

// Serialise a Date to a local-calendar "YYYY-MM-DD" string.
// Use this for date-only fields (DOB, issue/expiry dates) instead of
// date.toISOString() — toISOString converts to UTC, which shifts the
// stored day backwards by one when the browser is ahead of UTC (e.g. BST).
export const toDateOnlyString = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// Today's date as a local "YYYY-MM-DD" string (for max/default attributes).
export const todayDateOnlyString = (): string => toDateOnlyString(new Date());

export const formatDOB = (dob: string | Date): string => {
  const date = new Date(dob);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date format");
  }
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateTime = (dateTime: string | Date): string => {
  const date = new Date(dateTime);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date format");
  }
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }) + " at " + date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
};

export const formatDate = (dateString: string | Date): string => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};